import { render, staticRenderFns } from "./ManivoxTags.vue?vue&type=template&id=97bcd0e2&scoped=true&"
import script from "./ManivoxTags.vue?vue&type=script&lang=js&"
export * from "./ManivoxTags.vue?vue&type=script&lang=js&"
import style0 from "./ManivoxTags.vue?vue&type=style&index=0&id=97bcd0e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bcd0e2",
  null
  
)

export default component.exports